import { isWidthUp } from "material-ui/utils/withWidth";

import {
  REQUEST_ACCOUNT,
  REQUEST_ACCOUNTS,
  RECEIVE_ACCOUNTS
} from "../actions/accounts";

import {
  SET_NOTIFICATION,
  CLEAR_NOTIFICATION,
  SHOW_NOTIFICATION_DETAILS
} from "../actions/notifications";

import { REQUEST_USERS, RECEIVE_USERS } from "../actions/users";

import { SORT_BY, SET_ACCOUNTS_SORT, SET_PEOPLE_SORT } from "../actions/sort";

import {
  OPEN_DRAWER,
  CLOSE_DRAWER,
  SET_WIDTH,
  DRAWER_STATE
} from "../actions/drawer";

import { SET_OV_FILTER_VISIBILITY } from "../actions/overviewParams";
import { SET_UI_VIEW_MODE_FOCUS } from "../actions/ui";

import {
  REQUEST_COST_LIMITS,
  RECEIVE_COST_LIMITS
} from "../actions/costLimits";

import {
  RECEIVE_ACCOUNT_SETTINGS,
  RECEIVE_ACCOUNT_SETTINGS_FAILED,
  REQUEST_ACCOUNT_SETTINGS
} from "../actions/accountSettings";

const defaultSortOrder = {
  sortAccounts: SORT_BY.NAME,
  sortPeople: SORT_BY.ROLE
};

const notLoading = {
  loadingAccounts: false,
  loadingUsers: false,
  loadingCostLimits: false
};

const geometry = {
  geometry: {
    drawer: DRAWER_STATE.HIDDEN,
    width: "md"
  }
};

const overviewUI = {
  overviewFiltersVisible: true
};

const blankNotification = {
  notification: {},
  dialog: {}
};

const viewMode = {
  focused: false
};

export const initialState = {
  ...defaultSortOrder,
  ...blankNotification,
  ...notLoading,
  ...overviewUI,
  ...geometry,
  ...viewMode
};

function ui(state = initialState, action) {
  switch (action.type) {
    case REQUEST_ACCOUNT:
    case REQUEST_ACCOUNTS:
      return Object.assign({}, state, { loadingAccounts: true });

    case REQUEST_USERS:
      return Object.assign({}, state, { loadingUsers: true });

    case RECEIVE_ACCOUNTS:
      return Object.assign({}, state, { loadingAccounts: false });

    case RECEIVE_USERS:
      return Object.assign({}, state, { loadingUsers: false });

    case SET_NOTIFICATION:
      return Object.assign(
        {},
        state,
        {
          notification: {
            message: action.message,
            details: action.details,
            show: "snackbar",
            type: action.notificationType
          }
        },
        notLoading
      );

    case CLEAR_NOTIFICATION:
      return Object.assign({}, state, { notification: {} });

    case SHOW_NOTIFICATION_DETAILS:
      if (state.notification && state.notification.type) {
        const newNotification = Object.assign({}, state.notification, {
          show: "dialog"
        });
        return Object.assign({}, state, { notification: newNotification });
      } else {
        return state;
      }

    case SET_ACCOUNTS_SORT:
      return Object.assign({}, state, { sortAccounts: action.sortBy });

    case SET_PEOPLE_SORT:
      return Object.assign({}, state, { sortPeople: action.sortBy });

    case CLOSE_DRAWER:
      return Object.assign({}, state, {
        geometry: {
          width: state.geometry.width,
          drawer:
            state.geometry.drawer === DRAWER_STATE.FLOATING
              ? DRAWER_STATE.HIDDEN
              : state.geometry.drawer
        }
      });

    case OPEN_DRAWER:
      return Object.assign({}, state, {
        geometry: {
          width: state.geometry.width,
          drawer:
            state.geometry.drawer === DRAWER_STATE.HIDDEN
              ? DRAWER_STATE.FLOATING
              : state.geometry.drawer
        }
      });

    case SET_WIDTH:
      return Object.assign({}, state, {
        geometry: {
          width: action.width,
          drawer: isWidthUp("md", action.width)
            ? DRAWER_STATE.DOCKED
            : DRAWER_STATE.HIDDEN
        }
      });

    case SET_OV_FILTER_VISIBILITY:
      return Object.assign({}, state, {
        overviewFiltersVisible: action.visible
      });

    case REQUEST_COST_LIMITS:
      return { ...state, loadingCostLimits: true };

    case RECEIVE_COST_LIMITS:
      return { ...state, loadingCostLimits: false };

    case REQUEST_ACCOUNT_SETTINGS:
      return { ...state, loadingAccountSettings: true };

    case RECEIVE_ACCOUNT_SETTINGS:
    case RECEIVE_ACCOUNT_SETTINGS_FAILED:
      return { ...state, loadingAccountSettings: false };

    case SET_UI_VIEW_MODE_FOCUS:
      const focused = !!action.mode; // to coerce boolean
      return { ...state, focused };

    default:
      return state;
  }
}

export default ui;



// WEBPACK FOOTER //
// ./src/reducers/ui.js